import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  generateKey,
  getDateTimeFormate,
  setToLocalStorage,
  formatMoney,
  getConvertedAmountWithCurrency,
} from "../../sharedfiles/helper";
import Skelton from "../Common/skeleton/Skeleton";
import { tabManager } from "../sidebar/sidebarSlice";
import { AFFILIATE_CONSTANTS, COMMON_CONSTANTS } from "../../sharedfiles/Constants";
import NoDataFound from "../Common/table/NoDataFound";
import { CampaignInfo } from "../../sharedfiles/tooltipMsgs";
import Tooltips from "../Common/Tooltip";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../ui/table";
import { Button } from "../../ui/button";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";
import TableToolbar from "../Common/table/TableToolbar";
function CampaignTable(props) {
  const { data, viewTable } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const tabStack = useSelector((st) => st.sidebar.tabStack);
  const navigateToURL = (campaignId) => {
    setToLocalStorage("campaignId", campaignId);
    dispatch(tabManager("/campaignUrls", tabStack));
    history.push("/campaignUrls");
  };

  const headers = [
    "Id",
    "Campaign Name",
    "Created Date",
    "Updated Date",
    "View Campaign",
    "Total Registrations",
    "Deposited Customers",
    "Total Deposits",
    "New Customers",
    "Total Stakes",
    "Total Payout",
    "GGR",
    "Total Bonus Amount",
    "Total Number of Bets",
    "Total Withdrawals",
    "URL Hits Count",
  ]
  const campaignRowAccessors = [
    (item) => item.id,
    (item) => item.name,
    (item) => (item.createdDate ? getDateTimeFormate(item.createdDate) : "-"),
    (item) => (item.updatedDate ? getDateTimeFormate(item.updatedDate) : "-"),
    (item) => (
      <Button
        variant="default"
        size="sm"
        onClick={() => navigateToURL(item.id)}
      >
        View
      </Button>
    ),
    (item) => item.totalRegistration,
    (item) => item.depositedCustomers,
    (item) => getConvertedAmountWithCurrency(item.totalDeposit, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => item.newCustomers,
    (item) => getConvertedAmountWithCurrency(item.totalStake, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => getConvertedAmountWithCurrency(item.totalPayout, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => getConvertedAmountWithCurrency(item.totalGgr, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => (item.totalBonus ? item.totalBonus : "0"),
    (item) => item.betCount,
    (item) => getConvertedAmountWithCurrency(item.totalWithdraw, item.currencyCode || item.currency, item.baseCurrencyRate),
    (item) => item.campaignClickCount,
  ];
  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences("campaignCampaignTable", headers);

  return viewTable ? (

    <React.Fragment>
      <div className='relative rounded-lg border bg-card overflow-hidden'>
        <TableToolbar
          columns={allColumns}
          onToggle={toggleVisibility}
          onReorder={reorder}
          onReset={resetToDefault}
        />
        <div className='overflow-x-auto'>
          <Table scrollKey="campaignCampaignTable">
            <TableHeader>
              <TableRow>
                {visibleIndices.map((origIdx) => (
                  <TableHead key={origIdx} className="text-center">
                    <div className='flex justify-center items-center'>
                      <p className='mx-3'>{headers[origIdx]}</p>
                      <Tooltips info={`${CampaignInfo[origIdx]}`} />
                    </div>
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {data && Array.isArray(data) && data.length > 0 ? (
                data.map((item) => {
                  return (
                    <TableRow key={generateKey(item.id)}>
                      {visibleIndices.map((origIdx) => (
                        <TableCell key={origIdx} className="text-center">
                          {campaignRowAccessors[origIdx](item)}
                        </TableCell>
                      ))}
                    </TableRow>
                  );
                })
              ) : (
                <NoDataFound colspan={visibleIndices.length} />
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </React.Fragment>
  ) : (
    <Skelton />
  );
}

export default CampaignTable;
